import { css } from "styled-components";
import { Icon } from "../../../../../../components/Icon";
import { textUppercaseMixin } from "../../../../../../skins/shared/mixins/typography";
const playstationColor = "#002E7A";
const playstationHoverColor = "#00235B";
const playstationActiveColor = "#000F44";
const xboxColor = "#107C10";
const xboxHoverColor = "#076907";
const xboxActiveColor = "#005400";
export const riotProductSkin = (chroma, paletteTokens) => css `
  display: flex;
  gap: 32px;
  ${chroma.mediaQueries.mobileDown} {
    gap: 16px;
    flex-direction: column;
  }

  a {
    text-decoration: none;

    &.variant-playstation,
    &.variant-xbox {
      ${textUppercaseMixin};
      cursor: pointer;
      display: flex;
      justify-content: center;
      width: 200px;
      height: 62px;
      align-items: center;
      color: ${paletteTokens.accents1};
      ${chroma.typography.body3}
      padding: 19px 25px;
      font-size: 18px;
      font-weight: 700;

      ${chroma.mediaQueries.mobileDown} {
        padding: 20px 26px;
        font-size: 14px;
        width: 100%;
        height: 59px;
      }
    }

    ${Icon} {
      height: 24px;
      width: 24px;
      margin-right: 4px;
      mask-position: center;
      background-color: ${paletteTokens.accents1};
    }

    &.variant-xbox {
      background-color: ${xboxColor};

      &:hover {
        background-color: ${xboxHoverColor};
      }

      &:active {
        background-color: ${xboxActiveColor};
      }
    }

    &.variant-playstation {
      background-color: ${playstationColor};

      &:hover {
        background-color: ${playstationHoverColor};
      }

      &:active {
        background-color: ${playstationActiveColor};
      }
    }
  }
`;
//# sourceMappingURL=index.js.map